import isEqual from 'lodash/isEqual'
import get from 'lodash/get'

let watch = (state, objectPath) => {
  let currentValue = get(state, objectPath)
  return function w (fn) {
    return function () {
      let newValue = get(state, objectPath)
      if (!isEqual(currentValue, newValue)) {
        var oldValue = currentValue
        currentValue = newValue
        fn(newValue, oldValue, objectPath)
      }
    }
  }
}

export default (store) => {
  return (key, callback) => {
    let w = watch(store.state, key)
    return store.subscribe(w(callback))
  }
}
